"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var newsletterNormalizer = function (response) {
    var data = response.data;
    if (!data) {
        return __assign(__assign({}, response), { data: null });
    }
    return __assign(__assign({}, response), { data: {
            emailAddresses: __spreadArray([], (data.emails || []), true),
            emailType: data.email_type,
            subscribed: data.subscribed,
            couponSent: data.coupon_sent,
            doubleOptInEmailSent: data.double_opt_in_email_sent,
        } });
};
exports.default = newsletterNormalizer;
